import React, { useEffect, useState } from 'react'
import { FormCustom, Input, SwitchToggle } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'

const ProfileForm = ({ rowId, setReload }) => {
  const [row, setRow] = useState({
    p_id_profile: '',
    p_id_company: '',
    p_name_profile: '',
    p_enabled_profile: 0
  })
  const [ready, setReady] = useState(false);
  const dataSubmit = useMemo(() => {
    return row;
  }, [row])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/profile',
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/profile/' + rowId,
    rowId: rowId
  })

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          if (rowId) {
            setRow({
              p_id_profile: getRow.id_profile,
              p_id_company: getRow.id_company,
              p_name_profile: getRow.name_profile,
              p_enabled_profile: getRow.enabled_profile
            })
          }
          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <Input
        text="Nombre"
        placeholder="Nombre"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_name_profile}
        onChange={e => setRow({ ...row, p_name_profile: e.target.value })}
        maxLength={100}
      />
      <SwitchToggle
        id="profile-enabled"
        textCheck="Desactivar"
        textUnChecked="Activar"
        classNameParent="col-12 mb-3"
        checked={row.p_enabled_profile === 1}
        onChange={e => setRow({ ...row, p_enabled_profile: e.target.checked ? 1 : 0 })}
      />
    </FormCustom>
  </ReactPlaceholder>
}

ProfileForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  ProfileForm
};